var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "multiselect-wrapper", class: { deactive: this.disabled } },
    [
      _c(
        "div",
        { staticClass: "v-select vs--searchable vs--open display-multiselect" },
        [
          _c(
            "draggable",
            {
              on: {
                start: function ($event) {
                  this.dragging = true
                },
                end: function ($event) {
                  this.dragging = false
                },
              },
              model: {
                value: this.value,
                callback: function ($$v) {
                  _vm.$set(this, "value", $$v)
                },
                expression: "this.value",
              },
            },
            _vm._l(this.options, function (option, index) {
              return _c(
                "ul",
                {
                  key: index,
                  staticClass: "vs__selected vs__deselect selected-pills",
                },
                [
                  _c("li", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(option) +
                        "\n                    "
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "vs__deselect",
                        attrs: {
                          type: "button",
                          "aria-label": "deselect option",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.deselect(index)
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "10",
                              height: "10",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-select", {
        class: { deactive: this.disabled },
        attrs: {
          label: this.label,
          multiple: "",
          taggable: "",
          "push-tags": "true",
          options: this.options,
        },
        model: {
          value: this.value,
          callback: function ($$v) {
            _vm.$set(this, "value", $$v)
          },
          expression: "this.value",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }